var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { Component, Vue, Watch } from 'vue-facing-decorator';
import { ref, nextTick } from 'vue';
import { State } from "vuex-facing-decorator";
import { LoginState } from "@/app/store/modules/login.state";
import { Notifier } from "@/common/utils/notifier";
import { Feature, CompaniesClient, IssuesClient, SystemsClient, LookupsClient, IssueModel, IssueAction, IssueFieldType, SystemComponentsClient, SystemComponentTreeNodesClient, ComponentTypeEnum, IssueSeverity } from "@/app/api/battery-portal-api";
import { HttpHelper } from "@/app/utils/http-helper";
import { DateHelper } from "@/app/utils/date-helper";
import debounce from 'lodash/debounce';
import RichTextareaVue from '@/app/vues/components/rich-textarea.vue';
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const systemsClient = new SystemsClient(window.apiUrl);
const issuesClient = new IssuesClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const lookupsClient = new LookupsClient(window.apiUrl);
const componentClient = new SystemComponentsClient(window.apiUrl);
const systemComponentTreeNodesClient = new SystemComponentTreeNodesClient(window.apiUrl);
let IssueVue = class IssueVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.loaded = false;
        this.isEditingUrl = false;
        this.model = new IssueModel();
        this.companies = [];
        this.systems = [];
        this.strings = [{ value: null, text: 'Not defined' }];
        this.blocks = [];
        this.users = [{ value: null, text: 'Unassigned' }];
        this.attemptedSave = false;
        this.severities = [
            { value: 1, text: 'Critical' },
            { value: 2, text: 'Warning' },
            { value: 3, text: 'Info' },
            { value: 4, text: 'Ok' },
        ];
        this.blockSelectionInput = '';
        this.blockSelectionError = '';
        this.description = {
            input: '',
            suggestions: ref([]),
            showSuggestions: false,
            selectedIndex: -1
        };
        this.task = {
            input: '',
            suggestions: ref([]),
            showSuggestions: false,
            selectedIndex: -1
        };
        this.fieldConfigs = {
            description: {
                fieldType: IssueFieldType.Description,
                modelKey: 'description'
            },
            task: {
                fieldType: IssueFieldType.Task,
                modelKey: 'task'
            }
        };
        this.actionOptions = [
            { value: IssueAction.Watch, text: 'Watch' },
            { value: IssueAction.Task, text: 'Task' },
            { value: IssueAction.Resolved, text: 'Resolved' }
        ];
        this.dateConfig = {
            enableTime: true,
            dateFormat: "Y-m-d H:i",
            defaultDate: new Date(),
            wrap: true,
            allowInput: false,
            clickOpens: true,
            time_24hr: true
        };
        this.linkDialog = {
            url: '',
            text: '',
            show: false,
            selectedText: '',
            selectionStart: 0,
            selectionEnd: 0
        };
        this.linkDialogVisible = false;
        this.debouncedSearch = debounce((query, field, config) => __awaiter(this, void 0, void 0, function* () {
            if (!query) {
                field.suggestions = [];
                return;
            }
            try {
                const suggestions = yield issuesClient.getSuggestions({
                    fieldType: config.fieldType,
                    searchTerm: query
                });
                field.suggestions = [...suggestions];
                yield nextTick();
            }
            catch (ex) {
                console.error(`Error fetching ${config.modelKey} suggestions:`, ex);
                field.suggestions = [];
            }
        }), 300);
    }
    created() {
        this.model.action = IssueAction.Watch;
        this.description.input = this.model.description || '';
        this.task.input = this.model.task || '';
        this.model.urls = [''];
        this.model.severity = IssueSeverity.Info;
        if (this.$route.params.id) {
            this.loadIssue(this.$route.params.id);
        }
        else {
            this.getLookups().then(() => {
                const promises = this.assignFromQuery();
                Promise.all(promises).then(() => {
                    this.loaded = true;
                });
            });
        }
    }
    assignFromQuery() {
        const promises = [];
        const query = this.$route.query;
        if (!query)
            return promises;
        // Assign companyId and systemId
        const companyId = query.companyId ? Number(query.companyId) : undefined;
        const systemId = query.systemId ? Number(query.systemId) : undefined;
        const stringId = query.stringId ? Number(query.stringId) : undefined;
        try {
            var alarmIds = (query.alarmIds || '')
                .split(',')
                .map(id => Number(id.trim()))
                .filter(id => !isNaN(id));
            this.model.alarmIds = alarmIds;
        }
        catch (error) {
            this.model.alarmIds = [];
            console.error('Error parsing alarmIds from query:', error);
        }
        if (companyId) {
            this.model.companyId = companyId;
            const company = this.companies.find(c => c.value === companyId);
            if (company)
                this.company = company;
        }
        if (systemId) {
            this.model.systemId = systemId;
            const system = this.filteredSystems.find(s => s.value === systemId);
            if (system)
                this.system = system;
        }
        // Assign stringId if present
        if (stringId && !query.blockIds) {
            this.model.stringId = stringId;
            const promise = this.loadStrings(systemId).then(() => {
                const stringItem = this.strings.find(s => s.value === stringId);
                if (stringItem)
                    this.stringItem = stringItem;
                return this.loadBlocks(stringId)
                    .then(() => {
                    this.assignBlocksFromQuery(query.blockIds);
                });
            });
            promises.push(promise);
        }
        else if (query.blockIds) {
            const promise = this.loadBlocks(null)
                .then(() => {
                this.assignBlocksFromQuery(query.blockIds);
            });
            promises.push(promise);
        }
        // Assign description
        if (query.description) {
            this.model.description = String(query.description);
            this.description.input = String(query.description);
            this.setValues({ description: String(query.description) });
        }
        return promises;
    }
    assignBlocksFromQuery(blockIdsQuery) {
        if (!blockIdsQuery)
            return;
        let blockIds = [];
        if (Array.isArray(blockIdsQuery)) {
            blockIds = blockIdsQuery.map(id => Number(id)).filter(id => !isNaN(id));
        }
        else if (typeof blockIdsQuery === 'string') {
            blockIds = blockIdsQuery
                .split(',')
                .map(id => Number(id.trim()))
                .filter(id => !isNaN(id));
        }
        this.blocks.forEach(block => {
            block.selected = blockIds.includes(block.value);
        });
        this.model.components = this.blocks.filter(b => b.selected).map(b => b.value);
    }
    onSuggestionsChange(newVal) {
    }
    getLookups() {
        return __awaiter(this, arguments, void 0, function* (keepWorking = false) {
            this.working = true;
            try {
                const [companiesResponse, systemsResponse] = yield Promise.all([
                    companyClient.getListGET(),
                    systemsClient.getSystems(false, Feature.Issue_View)
                ]);
                this.companies = companiesResponse.map(c => ({
                    value: c.companyId,
                    text: c.companyName
                }));
                if (this.companies && this.companies.length == 1)
                    this.model.companyId = this.companies[0].value;
                this.systems = systemsResponse;
            }
            catch (ex) {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }
            finally {
                this.working = keepWorking;
            }
        });
    }
    loadStrings(systemId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!systemId) {
                this.strings = [{ value: null, text: 'Not defined' }];
                return;
            }
            try {
                const response = yield componentClient.getSystemStrings(systemId);
                this.strings = [
                    { value: null, text: 'Not defined' },
                    ...response.map(item => ({
                        value: item.componentId,
                        text: item.componentName || ""
                    }))
                ];
            }
            catch (ex) {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
                this.strings = [{ value: null, text: 'Not defined' }];
            }
        });
    }
    loadBlocks(stringId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.model.systemId) {
                this.blocks = [];
                return;
            }
            try {
                const response = yield systemComponentTreeNodesClient.getStringsAndBlocks(this.model.systemId);
                const allBlocks = this.findAllBlocksRecursivelyWithStringName(response.children);
                if (stringId) {
                    this.blocks = allBlocks.filter(block => this.isBlockChildOfString(block.block, stringId, response.children)).map(block => {
                        var _a;
                        return ({
                            value: block.block.componentId,
                            text: block.block.componentName || "",
                            code: block.block.componentCode,
                            string: block.stringName,
                            selected: ((_a = this.model.components) === null || _a === void 0 ? void 0 : _a.some(blockId => blockId === block.block.componentId)) || false
                        });
                    });
                }
                else {
                    this.blocks = allBlocks.map(block => {
                        var _a;
                        return ({
                            value: block.block.componentId,
                            text: block.block.componentName || "",
                            code: block.block.componentCode,
                            string: block.stringName,
                            selected: ((_a = this.model.components) === null || _a === void 0 ? void 0 : _a.some(blockId => blockId === block.block.componentId)) || false
                        });
                    });
                }
            }
            catch (ex) {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
                this.blocks = [];
            }
        });
    }
    findAllBlocksRecursivelyWithStringName(nodes) {
        let blocks = [];
        for (const node of nodes) {
            // If this node is a string, process its children blocks
            if (node.componentTypeId === ComponentTypeEnum.String) {
                const stringName = node.componentName || "Undefined String";
                // Find immediate block children
                if (node.children) {
                    for (const child of node.children) {
                        if (child.componentTypeId === ComponentTypeEnum.Block) {
                            blocks.push({
                                block: child,
                                stringName: stringName
                            });
                        }
                    }
                }
            }
            // Recursively search children (in case blocks are nested deeper)
            if (node.children && node.children.length > 0) {
                blocks = blocks.concat(this.findAllBlocksRecursivelyWithStringName(node.children));
            }
        }
        return blocks;
    }
    isBlockChildOfString(block, stringId, nodes) {
        for (const node of nodes) {
            // If this is our target string and it has our block as a child
            if (node.componentId === stringId && node.componentTypeId === ComponentTypeEnum.String) {
                return this.isBlockInChildren(block.componentId, node.children);
            }
            // If this node has children, recursively search them
            if (node.children && node.children.length > 0) {
                if (this.isBlockChildOfString(block, stringId, node.children)) {
                    return true;
                }
            }
        }
        return false;
    }
    isBlockInChildren(blockId, nodes) {
        if (!nodes)
            return false;
        for (const node of nodes) {
            // If this is our block, we found it
            if (node.componentId === blockId) {
                return true;
            }
            // If this node has children, recursively search them
            if (node.children && node.children.length > 0) {
                if (this.isBlockInChildren(blockId, node.children)) {
                    return true;
                }
            }
        }
        return false;
    }
    // Add getter/setter for blocks (multiple selection)
    get block() {
        var _a;
        if (!((_a = this.model.issueComponents) === null || _a === void 0 ? void 0 : _a.length))
            return [];
        return this.blocks.filter(item => this.model.issueComponents.some(c => c.componentId === item.value));
    }
    set block(items) {
        if (!items) {
            this.model.issueComponents = [];
            return;
        }
        // Update the issueComponents list
        this.model.issueComponents = items
            .filter(item => item.value) // Filter out the 'Not defined' option
            .map(item => ({
            componentId: item.value,
            componentName: item.text
        }));
    }
    loadIssue(id) {
        return __awaiter(this, void 0, void 0, function* () {
            this.working = true;
            if (!id)
                return;
            try {
                yield this.getLookups(true);
                const issue = yield issuesClient.get(parseInt(id));
                this.model = issue;
                this.description.input = this.model.description || '';
                this.task.input = this.model.task || '';
                if (!this.model.urls) {
                    this.model.urls = [''];
                }
                this.setValues({
                    description: this.model.description,
                    task: this.model.task || null,
                    resolved: this.model.resolved || null,
                    action: this.model.action
                });
            }
            catch (ex) {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }
            finally {
                this.loaded = true;
                this.working = false;
            }
        });
    }
    handleInput(event, field, config) {
        const value = event.target.value;
        field.input = value;
        field.showSuggestions = true;
        field.selectedIndex = -1;
        this.model[config.modelKey] = value;
        this.setValues({
            [config.modelKey]: value
        });
        this.debouncedSearch(value, field, config);
    }
    handleEnterKey(field, config) {
        if (field.showSuggestions && field.selectedIndex >= 0 && field.suggestions.length > 0) {
            this.selectSuggestion(field.suggestions[field.selectedIndex], field, config);
        }
        else {
            field.showSuggestions = false;
            field.selectedIndex = -1;
        }
    }
    handleBlur(field, config) {
        if (field.selectedIndex >= 0 && field.suggestions.length > 0) {
            const selectedValue = field.suggestions[field.selectedIndex];
            this.model[config.modelKey] = selectedValue;
            field.input = selectedValue;
            this.setValues({
                [config.modelKey]: selectedValue
            });
        }
        else if (field.input.trim()) {
            const trimmedValue = field.input.trim();
            this.model[config.modelKey] = trimmedValue;
            this.setValues({
                [config.modelKey]: trimmedValue
            });
        }
        setTimeout(() => {
            field.showSuggestions = false;
            field.selectedIndex = -1;
        }, 200);
    }
    selectSuggestion(suggestion, field, config) {
        this.model[config.modelKey] = suggestion;
        field.input = suggestion;
        field.showSuggestions = false;
        field.selectedIndex = -1;
        this.setValues({
            [config.modelKey]: suggestion
        });
    }
    navigateSuggestions(direction, field) {
        if (!field.showSuggestions)
            return;
        const newIndex = field.selectedIndex + direction;
        if (newIndex >= -1 && newIndex < field.suggestions.length) {
            field.selectedIndex = newIndex;
        }
    }
    clearSuggestions(field) {
        field.showSuggestions = false;
        field.selectedIndex = -1;
    }
    onCompanyChange() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            this.users = [{ value: null, text: 'Unassigned' }];
            if (!((_a = this.company) === null || _a === void 0 ? void 0 : _a.value))
                return;
            try {
                const users = yield lookupsClient.getUsersForMyCompanies(this.company.value);
                this.users = this.users.concat(users.map(u => ({
                    value: u.userId,
                    text: u.displayName
                })));
            }
            catch (ex) {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            }
        });
    }
    onSystemChange() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadStrings(this.model.systemId);
            this.string = this.strings[0];
            this.model.issueComponents = [];
            yield this.loadBlocks(this.model.stringId);
        });
    }
    onStringChange() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadBlocks(this.model.stringId);
            this.model.issueComponents = [];
        });
    }
    onActionChange() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.model.action === IssueAction.Resolved && !this.model.resolved) {
                this.model.resolved = new Date();
                this.setValues({
                    resolved: this.model.resolved
                });
                yield nextTick();
                // Reinitialize flat-pickr
                const flatpickrInputs = document.querySelectorAll('.flat-pickr-input');
                flatpickrInputs.forEach(input => {
                    const fp = input._flatpickr;
                    if (fp) {
                        fp.destroy();
                    }
                    flatpickr(input, this.dateConfig);
                });
            }
        });
    }
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.working)
                return;
            this.attemptedSave = true;
            if (!this.company) {
                Notifier.onWarning("Please select a company!");
                return;
            }
            if (!this.system) {
                Notifier.onWarning("Please select a system!");
                return;
            }
            // Set values for validation
            this.setValues({
                description: this.model.description,
                task: this.model.task,
                resolved: this.model.resolved,
                action: this.model.action
            });
            const handleSubmitAction = this.handleSubmit(() => __awaiter(this, void 0, void 0, function* () {
                this.working = true;
                this.model.components = this.blocks
                    .filter(b => b.selected)
                    .map(b => b.value);
                try {
                    this.model.resolved = this.model.resolved ? DateHelper.convertToDate(this.model.resolved.toString()) : null;
                    if (this.isNew) {
                        yield issuesClient.create(this.model);
                        Notifier.onOk('Issue created successfully');
                    }
                    else {
                        yield issuesClient.update(this.model.issueId, this.model);
                        Notifier.onOk('Issue updated successfully');
                    }
                    this.$router.back();
                }
                catch (ex) {
                    HttpHelper.handleResponse(ex, () => {
                        Notifier.onServerError(ex);
                    });
                }
                finally {
                    this.working = false;
                }
            }), (e) => {
                console.warn("validation", e);
                Notifier.onError("Please check that you have entered all details correctly.");
            });
            handleSubmitAction();
        });
    }
    cancel() {
        this.$router.back();
    }
    get pageTitle() {
        return this.isNew ? "New Issue" : `Editing Issue #${this.model.issueNumber}`;
    }
    ;
    startEditingUrl() {
        this.isEditingUrl = true;
    }
    finishEditingUrl() {
        this.isEditingUrl = false;
    }
    get isNew() {
        return !this.$route.params.id;
    }
    get filteredSystems() {
        return this.systems
            .filter(s => { var _a; return !((_a = this.company) === null || _a === void 0 ? void 0 : _a.value) || s.companyId === this.company.value; })
            .map(s => ({
            value: s.systemId,
            text: s.systemName
        }));
    }
    get company() {
        return this.companies.filter(item => {
            return item.value == this.model.companyId;
        })[0] || null;
    }
    set company(item) {
        if (!item)
            return;
        this.model.companyId = item.value;
    }
    get system() {
        return this.filteredSystems.filter(item => {
            return item.value == this.model.systemId;
        })[0] || null;
    }
    set system(item) {
        if (!item)
            return;
        this.model.systemId = item.value;
    }
    get stringItem() {
        return this.strings.filter(item => {
            return item.value == this.model.stringId;
        })[0] || null;
    }
    set stringItem(item) {
        if (!item)
            return;
        this.model.stringId = item.value;
    }
    get numberOfSelectedBlocks() {
        return this.blocks.filter(block => block.selected).length;
    }
    get blockSelectionText() {
        const selectedBlocks = this.blocks.filter(block => block.selected);
        if (selectedBlocks.length === 0)
            return '';
        if (selectedBlocks.length === this.blocks.length)
            return 'All blocks';
        // If a string is selected, use the original format
        if (this.model.stringId) {
            const blockCodes = selectedBlocks
                .map(block => parseInt(block.code || '0'))
                .sort((a, b) => a - b);
            return this.formatBlockRange(blockCodes);
        }
        // Group blocks by string
        const blocksByString = selectedBlocks.reduce((groups, block) => {
            const stringName = block.string || 'Undefined String';
            if (!groups[stringName]) {
                groups[stringName] = [];
            }
            groups[stringName].push(parseInt(block.code || '0'));
            return groups;
        }, {});
        // Format each string's blocks and combine
        return Object.entries(blocksByString)
            .map(([stringName, blockCodes]) => {
            const sortedCodes = blockCodes.sort((a, b) => a - b);
            return `${stringName}: ${this.formatBlockRange(sortedCodes)}`;
        })
            .join('; ');
    }
    formatBlockRange(blockCodes) {
        const ranges = [];
        let rangeStart = blockCodes[0];
        let rangeEnd = blockCodes[0];
        for (let i = 1; i <= blockCodes.length; i++) {
            if (i < blockCodes.length && blockCodes[i] === rangeEnd + 1) {
                // Continue current range
                rangeEnd = blockCodes[i];
            }
            else {
                // End of range or last number
                if (rangeStart === rangeEnd) {
                    // Single number
                    ranges.push(rangeStart.toString());
                }
                else {
                    // Range of numbers
                    ranges.push(`${rangeStart}-${rangeEnd}`);
                }
                if (i < blockCodes.length) {
                    // Start new range
                    rangeStart = blockCodes[i];
                    rangeEnd = blockCodes[i];
                }
            }
        }
        return ranges.join(', ');
    }
    clearBlockSelection() {
        // Deselect all blocks
        this.blocks.forEach(block => block.selected = false);
        // Clear the model
        this.model.issueComponents = [];
        // Clear any input or error states
        this.blockSelectionInput = '';
        this.blockSelectionError = '';
    }
    get assigned() {
        return this.users.filter(item => {
            return item.value == this.model.assignedId;
        })[0] || null;
    }
    set assigned(item) {
        if (!item)
            return;
        this.model.assignedId = item.value;
    }
    get severity() {
        return this.severities.filter(item => {
            return item.value == this.model.severity;
        })[0] || null;
    }
    set severity(item) {
        if (!item)
            return;
        this.model.severity = item.value;
    }
    addLink() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const richTextarea = this.$refs.notesTextarea;
                if (!richTextarea)
                    return;
                this.model.notes = this.model.notes || '';
                const selection = richTextarea.getSelection();
                if (!selection) {
                    Notifier.onWarning('Please place the cursor where you want to insert the link.');
                    return;
                }
                this.linkDialog = {
                    url: '',
                    text: selection.text || '',
                    show: true,
                    selectedText: selection.text,
                    selectionStart: selection.start,
                    selectionEnd: selection.end,
                    formattedStart: selection.formattedStart
                };
                this.linkDialogVisible = true;
            }
            catch (ex) {
                console.error('Failed to open link dialog: ' + ex.message);
            }
        });
    }
    insertLink() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const richTextarea = this.$refs.notesTextarea;
                if (!richTextarea)
                    return;
                const { url, text } = this.linkDialog;
                richTextarea.insertLink(url, text);
                this.linkDialogVisible = false;
            }
            catch (ex) {
                console.error('Failed to insert link: ' + ex.message);
                this.linkDialogVisible = false;
            }
        });
    }
    handleModalEnter(event) {
        event.preventDefault();
        if (this.linkDialog.url && this.linkDialog.text) {
            this.insertLink();
        }
    }
    get isBlockSelectionInputValid() {
        if (!this.blockSelectionInput)
            return null;
        return this.validateBlockSelectionFormat(this.blockSelectionInput);
    }
    validateBlockSelectionFormat(input) {
        return /^[\d,-\s]+$/.test(input) && // Only allows numbers, commas, dashes and spaces
            !/,\s*,/.test(input) && // No empty items between commas
            !/-\s*-/.test(input) && // No empty ranges
            !/^[,-]/.test(input) && // Doesn't start with comma or dash
            !/[,-]$/.test(input); // Doesn't end with comma or dash
    }
    parseBlockSelection(input) {
        const result = [];
        const parts = input.split(',').map(p => p.trim());
        try {
            for (const part of parts) {
                if (part.includes('-')) {
                    const [start, end] = part.split('-').map(n => parseInt(n.trim()));
                    if (isNaN(start) || isNaN(end) || start > end) {
                        throw new Error(`Invalid range: ${part}`);
                    }
                    for (let i = start; i <= end; i++) {
                        result.push(i);
                    }
                }
                else {
                    const num = parseInt(part.trim());
                    if (isNaN(num)) {
                        throw new Error(`Invalid number: ${part}`);
                    }
                    result.push(num);
                }
            }
        }
        catch (error) {
            this.blockSelectionError = error.message;
            return [];
        }
        return [...new Set(result)].sort((a, b) => a - b); // Remove duplicates and sort
    }
    // Add method to apply the selection
    handleBlockInput(query) {
        // User is typing (query has value)
        this.blockSelectionInput = query;
        if (query) {
            if (this.isBlockSelectionInputValid) {
                this.applyBlockSelection();
            }
        }
    }
    applyBlockSelection() {
        if (!this.validateBlockSelectionFormat(this.blockSelectionInput)) {
            this.blockSelectionError = 'Invalid format. Use numbers, commas, and dashes (e.g. 1-3,5,7-9)';
            return;
        }
        const selectedCodes = this.parseBlockSelection(this.blockSelectionInput);
        if (selectedCodes.length === 0)
            return;
        // First deselect all blocks
        this.blocks.forEach(block => block.selected = false);
        // Select blocks that match the codes
        this.blocks.forEach(block => {
            const blockCode = parseInt(block.code || '0');
            if (selectedCodes.includes(blockCode)) {
                block.selected = true;
            }
        });
        // Update the model
        this.model.issueComponents = this.blocks
            .filter(block => block.selected)
            .map(block => ({
            componentId: block.value,
            componentName: block.text
        }));
        // Clear error
        this.blockSelectionError = '';
        // Don't clear blockSelectionInput here - it will be cleared in nextTick in handleBlockInput
    }
    get isAdministrator() {
        return this.loginState.isPowerShieldAdministrator;
    }
    ;
};
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_a = typeof LoginState !== "undefined" && LoginState) === "function" ? _a : Object)
], IssueVue.prototype, "loginState", void 0);
__decorate([
    Watch('filteredSuggestions'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], IssueVue.prototype, "onSuggestionsChange", null);
__decorate([
    Watch('model.companyId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], IssueVue.prototype, "onCompanyChange", null);
__decorate([
    Watch('model.systemId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], IssueVue.prototype, "onSystemChange", null);
__decorate([
    Watch('model.stringId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], IssueVue.prototype, "onStringChange", null);
__decorate([
    Watch('model.action'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], IssueVue.prototype, "onActionChange", null);
IssueVue = __decorate([
    Component({
        name: "IssueVue",
        components: {
            RichTextareaVue,
        },
        setup() {
            const { errors, handleSubmit, defineInputBinds, defineComponentBinds, setValues } = useForm({
                validationSchema: yup.object({
                    description: yup.string()
                        .trim()
                        .required('Description is required')
                        .max(250, 'Description must be less than 250 characters'),
                    task: yup.string()
                        .nullable()
                        .when('action', {
                        is: (action) => action === IssueAction.Task,
                        then: (schema) => schema.required('Task is required'),
                        otherwise: (schema) => schema.optional()
                    }),
                    resolved: yup.date()
                        .nullable()
                        .when('action', {
                        is: (action) => action === IssueAction.Resolved,
                        then: (schema) => schema.required('Resolution date is required'),
                        otherwise: (schema) => schema.nullable()
                    }),
                }),
            });
            const descriptionVal = defineInputBinds('description');
            const taskVal = defineInputBinds('task');
            const resolvedVal = defineInputBinds('resolved');
            return {
                errors,
                handleSubmit,
                setValues,
                descriptionVal,
                taskVal,
                resolvedVal
            };
        }
    })
], IssueVue);
export default IssueVue;
